module.exports = __webpack_public_path__ + "media/images/flags/64/Tanzania-851f5603863530e7d47ac9fc25f1e916.png";